import { useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Whether the nutrition calculator should use its full-width small screen
 * layout, based on the width left after side insets such as the iPhone Duo rail.
 */
export const useNutritionCalculatorSmallScreen = () => {
  const { width: viewportWidth } = useWindowDimensions();
  const { right: safeAreaRightInset, left: safeAreaLeftInset } = useSafeAreaInsets();

  const availableWidth = viewportWidth - safeAreaLeftInset - safeAreaRightInset;

  return availableWidth <= SMALL_SCREEN_MAX_WIDTH;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SMALL_SCREEN_MAX_WIDTH = 460;
